import { useDispatch } from 'react-redux'
import moment from 'moment'
import Clear from '@mui/icons-material/Clear'
import { Checkbox, FormControlLabel, Grid } from '@mui/material'
import { CatalogueEntry } from 'models/catalogues'
import { selectCatalogue, selectInvoicesFilter } from 'lib/helpers/selectors'
import { useAppSelector } from 'store/hooks'
import { setFilter } from 'actions/invoices'
import { useCFDIsContainerContext } from 'containers/Invoices/CFDIs/CFDIsContainer/CFDIsContainer'
import Button from 'components/Shared/Button/Button'
import IOCustomForm from 'components/FormComponents/IOComponents/IOCustomForm/IOCustomForm'
import AutocompleteField from 'components/FormComponents/IOComponents/AutocompleteField/AutoCompleteField'
import DateField from 'components/FormComponents/IOComponents/DateField/DateField'
import TextField from 'components/FormComponents/IOComponents/TextField/TextField'
import './styles.scss'

const CFDIsAdvancedFilters = () => {
  const { CFDIsPaginatedData, isCFDIsTab, onResetFilters } =
    useCFDIsContainerContext()

  const { isLoading } = CFDIsPaginatedData

  const dispatch = useDispatch()

  const filters = useAppSelector(selectInvoicesFilter)
  const tipoComprobantes = useAppSelector(selectCatalogue('tiposComprobantes'))

  return (
    <IOCustomForm
      id="CFDIsAdvancedFilters"
      onSubmit={async form => {
        dispatch(
          setFilter({
            type: form.type,
            status: form.status,
            startDate: form.startDate,
            endDate: form.endDate,
            receptor: form.receptor,
          })
        )
      }}>
      <Grid
        className="collapsed-container advance-search"
        container
        spacing={4}
        alignItems="center">
        <Grid item xs={3}>
          <AutocompleteField
            name="type"
            label={'Ingreso/Egreso'}
            catalogue={tipoComprobantes.filter(
              c => ['I', 'E'].indexOf(c.value) > -1
            )}
            value={filters?.type}
            getOptionLabel={(o: CatalogueEntry) => `${o.label}`}
            renderOption={(o: CatalogueEntry) => (
              <span className="catalogue-option">{`${o.label}`}</span>
            )}
            getOptionSelected={(
              option: CatalogueEntry,
              value: CatalogueEntry
            ) => option.idCatalogValues === value.idCatalogValues}
            fullWidth
          />
        </Grid>
        {isCFDIsTab && (
          <Grid item xs={3}>
            <AutocompleteField
              name="status"
              label={'Estatus'}
              catalogue={[
                { idCatalogValues: 1, value: 1, label: 'Vigente' },
                { idCatalogValues: 2, value: 2, label: 'Cancelado' },
                { idCatalogValues: 3, value: 3, label: 'Pendiente' },
              ]}
              value={filters?.status}
              getOptionLabel={(o: CatalogueEntry) => `${o.label}`}
              renderOption={(o: CatalogueEntry) => (
                <span className="catalogue-option">{`${o.label}`}</span>
              )}
              getOptionSelected={(
                option: CatalogueEntry,
                value: CatalogueEntry
              ) => option.idCatalogValues === value.idCatalogValues}
              fullWidth
            />
          </Grid>
        )}

        <Grid item xs={3}>
          <DateField
            name="startDate"
            label="Fecha inicial"
            value={filters?.startDate ?? null}
            filterIn={(v: any) => (v ? moment(v, 'YYYY-MM-DD') : v)}
            filterOut={(v: any) => v?.format('YYYY-MM-DD')}
            disableFuture
            clearable
            fullWidth
            autoOk
          />
        </Grid>
        <Grid item xs={3}>
          <DateField
            name="endDate"
            label="Fecha final"
            value={filters?.endDate ?? null}
            filterIn={(v: any) => (v ? moment(v, 'YYYY-MM-DD') : v)}
            filterOut={(v: any) => v?.format('YYYY-MM-DD')}
            disableFuture
            clearable
            fullWidth
            autoOk
          />
        </Grid>
        <Grid item xs={3}>
          <TextField
            name="receptor"
            label="RFC del receptor"
            value={filters?.receptor}
            fullWidth
          />
        </Grid>
        {isCFDIsTab && (
          <Grid item xs={3}>
            <FormControlLabel
              control={<Checkbox />}
              label="Incluir todos los espacios de trabajo"
            />
          </Grid>
        )}

        <Grid item xs={3} />
        <Grid item xs={isCFDIsTab ? 3 : 12} className="advance-filters-actions">
          <Button
            id="cleanFiltersBtn"
            variant="hover"
            color="secondary"
            startIcon={<Clear />}
            onClick={onResetFilters}>
            Limpiar filtros
          </Button>
          <Button
            id="advanceSearchBtn"
            type="submit"
            variant="contained"
            color="secondary"
            activity={isLoading}>
            Buscar
          </Button>
        </Grid>
      </Grid>
    </IOCustomForm>
  )
}

export default CFDIsAdvancedFilters
